import React from 'react'
import Testimonials from './Testimonials'
import SectionTitle2 from '../../components/SectionTitle/SectionTitle2'

function Reviews() {
  return (
    <>
    <SectionTitle2 title="Students Reviews" />
    <Testimonials />
    </>
  )
}

export default Reviews